<template>
  <b-container class="temporarios">
    <h2>Cadastro Professores Temporários</h2>
    <div class="temporarios-body">
      <div class="temporarios-list" v-loading="loading">
        <ul>
          <li
            :class="{
              'temporarios-list__item': true,
              active: isActive(`${temp.id}`),
            }"
            v-for="temp in temporarios"
            :key="temp.id"
          >
            <a
              :class="{
                'temporarios-list__item-link': true,
                active: isActive(`${temp.id}`),
              }"
              @click.prevent="setActive(`${temp.id}`)"
              :href="`#${temp.titulo}`"
              >{{ temp.titulo }}</a
            >
          </li>
        </ul>
      </div>
      <div
        class="temporarios-component"
        v-loading="loadingActive"
        v-if="!loading"
      >
        <ul v-if="tempActive && tempActive.length">
          <li v-for="data in tempActive" :key="data.id">
            <a :href="data.arquivo" target="_blank">{{ data.titulo }}</a>
          </li>
        </ul>
        <span v-else-if="!loadingActive && !loading"
          >Não foram encontrados resultados para essa busca.</span
        >
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "temporarios",
  data() {
    return {
      loading: false,
      loadingActive: false,
      temporarios: [],
      tempActive: [],
      activeItem: "",
    };
  },
  methods: {
    async getTemporarios() {
      this.loading = true;
      this.temporarios = [];
      const res = await this.$axios
        .get(`professores-temporarios`)
        .catch((e) => {
          console.error("Temporários", e);
        });
      if (res.status === 200) {
        this.temporarios = res.data;
        this.setActive(this.temporarios[0].id);
      }
      this.loading = false;
    },
    async getTemporariosActive(id) {
      this.loadingActive = true;
      const res = await this.$axios
        .get(`professores-temporarios/${id}`)
        .catch((e) => {
          console.error("Temporários", e);
        });
      if (res.status === 200) {
        this.tempActive = res.data;
      }
      this.loadingActive = false;
    },

    isActive(menuItem) {
      return this.activeItem.toString() === menuItem.toString();
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
      this.getTemporariosActive(menuItem);
    },
  },
  created() {
    this.getTemporarios();
  },
};
</script>

<style lang="scss">
.temporarios {
  &.container {
    padding: 30px 20px;
    text-align: left;
  }
  font-family: Poppins;
  // font-size: 14px;
  font-size: var(--font-size--default);
  h4,
  h2 {
    color: var(--color-text-title);
    font-weight: bold;
    text-align: left;
  }

  &-body {
    display: flex;
  }

  &-list {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        background: var(--background-color-secondary);
        padding: 20px;
        border-radius: 0;
        margin: 0 1px 0 0;
        font-style: normal;
        font-weight: 400;
        border-top: 1px solid #dddddd;
        width: 300px;

        &:first-child {
          border-top: none;
        }
        & a {
          color: #87a8cc;
          &.active {
            color: #1f387f;
          }
        }

        &.active {
          background: #87a8cc;
        }
      }
    }
  }

  &-component {
    padding: 0 20px;
    width: 100%;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        border-top: 1px solid #dddddd;
        padding: 10px 0;
        text-align: justify;
        &:first-child {
          border-top: none;
        }
        span {
          color: #007bff;
          text-decoration: none;
          background-color: transparent;
          cursor: pointer;
          &:hover {
            color: #0056b3;
            text-decoration: underline;
          }
        }
      }
    }
    .pg {
      ul {
        li {
          border: none;
        }
      }
    }
  }
}
.custom-content {
  ul {
    list-style: none;
    padding: 0 10px;
    margin: 0;
    li {
      padding: 10px;
    }
  }
}

@media only screen and (max-width: 720px) {
  .temporarios {
    &.container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    &-body {
      flex-direction: column-reverse;
      align-items: center;
    }
  }
}
</style>
